import { fetchResumeSearch, getDataFromTemplate, reachUserCrateResumeLimit } from "@/http/api"
import { InfiniteScroll, Popup, Toast } from "antd-mobile"
import { useEffect, useReducer, useState } from "react"
import config from "@/pages/Home/config"
import { Ellipsis } from "antd-mobile"
import { useNavigate } from "react-router-dom"
import getQuery from "@/utils/getQuery"
import strictStringify from "@/common/strictStringify"
import {
    ResumeListStyled,
    TagStyled,
    PopupContentStyled,
    ResumeButton,
    rightSvg
} from './ResumeListStyled'
import { useImmerReducer } from "use-immer"
import { isEmpty } from "lodash"
import RatioImg from "@/pages/Mobile/components/RatioImg"
import isLogin from "@/common/isLogin"
import errorSlice from "@/redux/services/errorSlice"
import store from "@/redux/store"

// const MobileUseList = config.find(item => item.title === '行业').children

const limit = 6

const initialState = {
    dataList: [],
    filter: {
        use: '全部', // 用途
        searchWord: '', // 关键词
        position: '全部',
        profession: '全部',
        style: '全部',
    },
    hasMore: true, // 
    current: 1,
    loading: false,
}

const listReducer = (draft, action) => {
    switch (action.type) {
        case 'init':{
            draft.current = 1
            draft.dataList = []
            draft.hasMore = true
            break
        }
        case 'loading': {
            draft.loading = true
            break
        }
        case 'changed': {
            draft.current += 1
            draft.dataList.push(...action.data)
            if (action.data.length < limit) {
                draft.hasMore = false
            } else {
                draft.hasMore = true
            }
            draft.loading = false
            break
        }
        case 'updateFilter': {
            draft.filter = {
                ...draft.filter,
                ...action.filter
            }
            draft.current = 1
            draft.dataList = []
            draft.hasMore = true
            break
        }
        default:
            break;
    }
}

const ResumeList = ({ home, filter = {}, style }) => {
    const navigate = useNavigate()
    const [state, dispatch] = useImmerReducer(listReducer, {
        ...initialState,
        filter: {
            ...initialState.filter,
            ...filter
        }
    })
    const { position } = state.filter
    const [btnLoading, setBtnLoading] = useState(false)
    const [selectTemplate, setSelectTemplate] = useState({})
    const [visible, setVisible] = useState(false)
    useEffect(() => {
        if (!isEmpty(filter)) {
            dispatch({
                type: 'updateFilter',
                filter
            })
        }
    }, [filter])

    const fetchList = async () => {
        const res = await fetchResumeSearch({
            query: {
                page: state.current,
                limit: 6,
                ...state.filter
            },
        })
        const { dataList } = res;
        dispatch({
            type: 'changed',
            data: dataList || []
        })
    };

    const handleClickTemplate = (template) => {
        setVisible(true)
        setSelectTemplate(template)
    }

    const handleSelectTemplate = async () => {
        if (!isLogin()) {
            store.dispatch(errorSlice.actions.setCode(1009))
            return 
        }
        if (btnLoading) return 
        setBtnLoading(true)
        getDataFromTemplate({query: {resumeId: selectTemplate.id}}).then(res => {
            if (res) {
                const query = {
                    absolute_laout: getQuery().absolute_laout, id: res.id
                }
                navigate("/mobile/resume" + strictStringify(query))
            } else {
                Toast.show("网络繁忙，请重试")
            }
        }).finally(() => {
            setBtnLoading(false)
        })
    }

    const handleClickAll = () => {
        navigate('/mobile/template')
    }

    return <ResumeListStyled style={style}>
        {
            home && <div className="header flex justify-between items-center">
                <h2>简历模板</h2>
                <span className="flex-center" onClick={handleClickAll}>
                    <div className="pr-5">全部模板</div>
                    {rightSvg}
                </span>
            </div>    
        }
        

        <div className="resume-wrap">
            {/* {
                home && <div className="resume-use flex-center justify-start">
                    {
                        MobileUseList.map(item => {
                            return <TagStyled
                                onClick={() => dispatch({
                                    type: 'updateFilter',
                                    filter: {
                                        position: item
                                    }
                                })}
                                $active={item === position}
                                key={item}
                                className="flex-center"
                            >{item}</TagStyled>
                        })
                    }
                </div>
            } */}
            <div className="resume-list">
                {
                    state.dataList.map(item => {
                        return <div key={item.id} className="resume-item" onClick={() => handleClickTemplate(item)}>
                            <RatioImg className="resume-item-img" src={item.cover} ratio={[794, 1103]} />
                            <Ellipsis className="resume-item-title" direction='end' content={item.name} />
                        </div>
                    })
                }
            </div>
            <InfiniteScroll loadMore={fetchList} hasMore={state.hasMore} />
        </div>
        
        <Popup 
            visible={visible}
            onMaskClick={() => setVisible(false)}
            onClose={() => setVisible(false)}
            showCloseButton
            bodyStyle={{
                borderTopLeftRadius: '8px',
                borderTopRightRadius: '8px',
                minHeight: '40vh',
            }}
        >
            <PopupContentStyled style={{ padding: 20 }}>
                <Ellipsis className="resume-title" direction='end' content={selectTemplate.name} />
                <img style={{ width: '100%' }} src={selectTemplate.cover} /> 

                <ResumeButton $loading={btnLoading} onClick={handleSelectTemplate} className="resume-btn">使用此模板</ResumeButton>
            </PopupContentStyled>
        </Popup>
    </ResumeListStyled>
}

export default ResumeList